import React from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import addplanimage from "../../assets/landing_page/new/Organizing projects-rafiki 1.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setTemplateForCreate } from "../../Slices/planslice";
function EmptyPlan() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
        dispatch(setTemplateForCreate({ isTemplate: false,
              table: false, }));
    navigate("/home/createplan");
  };
  return (
    <div
      style={{
        border: "2px dotted #ccc",
        borderRadius: "8px",
        padding: "20px",
        textAlign: "center",
        margin: "0 auto",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center", // Center content vertically
        alignItems: "center", // Center content horizontally
      }}>
      <img
        src={addplanimage}
        alt='Placeholder'
        style={{
          width: "150px",
          height: "150px",
          objectFit: "cover",
          marginBottom: "16px",
        }}
      />
      <div
        style={{
          marginBottom: "16px",
          fontFamily: "Inter, sans-serif", // Include fallback font
          fontSize: "14px",
          fontWeight: 500,
          lineHeight: "16.94px",
          textAlign: "left",
        }}>
        Begin your project journey by creating a new plan
      </div>
      <Button
        variant='contained'
        onClick={handleClick}
        sx={{
          fontFamily: "Inter, sans-serif",
          textTransform: "none",
          fontWeight: 500,
          backgroundColor: "#FF2800",
          padding: "6px 16px",
          "&:hover": {
            backgroundColor: "#FF2800",
          },
        }}
        startIcon={<AddIcon />}>
        New Plan
      </Button>
    </div>
  );
}

export default EmptyPlan;
